
      import { Buffer } from "buffer"
      import process from "process"

      // // Shims to make postman-collection work
      window.Buffer = Buffer
      window.process = process
    